export default {"src":"/_next/static/media/logo.a07a7636.svg","height":14,"width":88,"blurWidth":0,"blurHeight":0};